export default "__VITE_ASSET__BuPL71Sb__"